module.exports = __webpack_public_path__ + "std/img/bg.e6bbfd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/views/My/Base/components/VipInfo/images/bg.svg
// module id = AdGy
// module chunks = 0